// /pdf/pdfBuilder.js
import jsPDF from "jspdf";

export function createPdf(fileName) {
    const doc = new jsPDF();

    const addHeader = async ({ logo, project, authority, city, year }) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        let y = 15;

        if (logo) {
            doc.addImage(logo, "PNG", pageWidth / 2 - 10, 5, 20, 20);
        }
        y += 18;
        // Project name

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(project, pageWidth / 2, y, { align: "center" });

        y += 6;

        // Authority name
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(authority, pageWidth / 2, y, { align: "center" });

        y += 6;

        // City name
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`${city}, ${year}`, pageWidth / 2, y, { align: "center" });
        y += 8;
        return y + 10; // return the "safe" Y to start content
    };

    const addFooter = async (logo) => {
        const pageCount = doc.internal.getNumberOfPages();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 14; // left/right margin

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);

            // Divider line above footer
            doc.setLineWidth(0.5);
            doc.line(margin, pageHeight - 20, pageWidth - margin, pageHeight - 20);

            // Left side: Logo + "Design & Developed by Tiller"
            const textY = pageHeight - 12; // vertical position for text
            const textX = margin + 17; // start text after logo width + spacing

            if (logo) {
                const logoSize = 16;
                const logoY = textY - logoSize / 2 + 2; // vertically center the logo with text
                doc.addImage(logo, "PNG", margin, logoY, logoSize, logoSize);
            }

            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Design & Developed by Tiller", textX, textY);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Tiller", textX, textY + 5);

            // Right side: Date, Time, Auto-generated message
            const date = new Date();
            const dateTimeStr = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
            const rightText = `Auto-generated Report `;
            const rightDate = `${dateTimeStr}`
            doc.text(rightText, pageWidth - margin, textY, { align: "right" });
            doc.text(rightDate, pageWidth - margin, textY + 5, { align: "right" });

            // Optional: Page number in center
            doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, textY, { align: "center" });
        }
    };


    return {
        doc,
        addHeader,
        addFooter,
        save: () => doc.save(fileName),
    };
}



